module.exports = __webpack_public_path__ + "static/img/5.caaa2581.png";